import { toast } from "react-toastify"
import { getSymbolFromCode } from "currency-code-symbol-map";
import {
  notificationSubscribe,
  notificationUnSubscribe,
} from "../components/AppSlice";
import { apiCaller } from "../api/apiCaller";
import { biReportLinksV2, userApi, paymentSearchApi } from "./EndpointConfig";
import { setBiReportURLs } from "../components/Reports/BiReports/bireportSlice";
import axios from "axios";

export const getBrowserDate = (date) => {
  var senddate = "";
  if (date != null || (undefined && date.indexOf("UTC") !== -1)) {
    senddate = date.replace("[UTC]", "");
  } else {
    senddate = date;
  }
  let placeddate = new Date(senddate);

  var setTime =
    placeddate.getHours() +
    ":" +
    placeddate.getMinutes() +
    ":" +
    placeddate.getSeconds();
  var fullTime = placeddate.toLocaleDateString() + " " + setTime;
  return fullTime;
};
export const getUtcDate = (date) => {
  var utcDate = new Date(date).toISOString();
  return utcDate;
};

export const getDate = (date) => {
  let dateString = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0];
}

export const getDecimalNumber = (number) => {
  if (number != null || undefined) {
    return Number(number).toFixed(2);
  } else {
    return 0;
  }
};
export const getDateFormate = (birth_date) => {
  if (birth_date != null || undefined) {
    let birthdate = new Date(birth_date);
    let getMonth = Number(birthdate.getMonth()) + 1;
    let getFullMonth = "";
    if (getMonth.toString().length < 2) {
      getFullMonth = "0" + getMonth;
    } else {
      getFullMonth = getMonth;
    }

    let getDay = "";
    if (birthdate.getDate().toString().length < 2) {
      getDay = "0" + birthdate.getDate();
    } else {
      getDay = birthdate.getDate();
    }
    var fullDate = getDay + "/" + getFullMonth + "/" + birthdate.getFullYear();

    return fullDate;
  } else {
    return "-";
  }
};

export const getBirthDate = (birth_date) => {
  if (birth_date != null || undefined) {
    let birthdate = new Date(birth_date);
    let getMonth = Number(birthdate.getMonth()) + 1;
    let getFullMonth = "";
    if (getMonth.toString().length < 2) {
      getFullMonth = "0" + getMonth;
    } else {
      getFullMonth = getMonth;
    }

    let getDay = "";
    if (birthdate.getDate().toString().length < 2) {
      getDay = "0" + birthdate.getDate();
    } else {
      getDay = birthdate.getDate();
    }
    // var fullDate = getDay + "/" + getFullMonth + "/" + birthdate.getFullYear();
    var fullDate = birthdate.getFullYear() + "-" + getFullMonth + "-" + getDay;
    return fullDate;
  } else {
    return 0;
  }
};

export const formatMoney = (number) => {
  const value = Number(number) / 100;
  return (Number.isFinite(value) ? value : 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const MULTIPLIER_100_CURRENCIES = ['USD', 'ARS', 'BOB', 'CLP', 'MXN', 'USDT', 'USDC', 'DAI', 'ADA', 'TRX', 'KES', 'BRL'];

export const convertAmountByCurrency = (amount, currencyCode) => {
  if (amount === null || amount === undefined) return 0;
  if (!currencyCode) return Number(amount);
  const divisor = MULTIPLIER_100_CURRENCIES.includes(currencyCode.toUpperCase()) ? 100 : 10000000000;
  return Number(amount) / divisor;
};

// convertAmountByCurrency as a plain input string - avoids exponent notation
// for tiny 10-decimal amounts (e.g. 1e-7) and drops trailing zeros.
export const amountInputValue = (amount, currencyCode) => {
  return convertAmountByCurrency(amount, currencyCode).toFixed(10).replace(/\.?0+$/, "");
};

// Inverse of convertAmountByCurrency - converts an entered amount into the
// API's minor units (x100 for MULTIPLIER_100_CURRENCIES, x10000000000 for
// the rest). Falls back to x100 when no currency is given. Rounded to avoid
// float artifacts on decimal input (e.g. 1.13 * 100 = 112.99999999999999).
export const amountUnitConversion = (amount, currencyCode) => {
  const multiplier = !currencyCode || MULTIPLIER_100_CURRENCIES.includes(currencyCode.toUpperCase()) ? 100 : 10000000000;
  return Math.round(Number(amount) * multiplier);
};

// Input regex for an amount in the given currency - allows up to 2 decimals
// for MULTIPLIER_100_CURRENCIES (or no currency) and up to 10 for the rest.
export const amountDecimalRegex = (currencyCode) => {
  const decimals = !currencyCode || MULTIPLIER_100_CURRENCIES.includes(currencyCode.toUpperCase()) ? 2 : 10;
  return new RegExp(`^\\d+(\\.\\d{0,${decimals}})?$`);
};

export const formatAmountByCurrency = (amount, currencyCode) => {
  if (amount === null || amount === undefined) return "-";
  if (!currencyCode) return amount;
  const is100 = MULTIPLIER_100_CURRENCIES.includes(currencyCode.toUpperCase());
  const divisor = is100 ? 100 : 10000000000;
  const converted = Number(amount) / divisor;
  return converted.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: is100 ? 2 : 10,
  });
};

// Formats a USD amount the backend has already computed (e.g. `stakeUsd`,
// `maxStakeUsd`) - unlike formatAmountByCurrency, no currency divisor/
// conversion is applied here since the value is already a literal USD
// figure. Keeps a minimum of 2 decimal places but preserves extra precision
// for small values (e.g. 0.0023) instead of rounding them down to "0.00".
// INT-10480: Referral List / Referral Details Stake USD display.
export const formatUsdAmount = (amount) => {
  if (amount === null || amount === undefined || amount === "") return "-";
  const value = Number(amount);
  if (!Number.isFinite(value)) return "-";
  return `$${value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 6 })}`;
};

// Truncates (does NOT round) a number to the given decimal places, e.g.
// truncateDecimals(0.9989) -> 0.99. Returns null for null/empty/non-numeric input.
export const truncateDecimals = (amount, decimals = 2) => {
  if (amount === null || amount === undefined || amount === "") return null;
  const value = Number(amount);
  if (!Number.isFinite(value)) return null;
  const [intPart, decPart = ""] = String(value).split(".");
  return Number(`${intPart}.${decPart.slice(0, decimals)}`);
};

// Same display as formatUsdAmount but truncated to a fixed number of
// decimals instead of rounded, e.g. 999.98515924 -> "$999.98".
export const formatTruncatedUsdAmount = (amount, decimals = 2) => {
  const truncated = truncateDecimals(amount, decimals);
  if (truncated === null) return "-";
  return `$${truncated.toLocaleString("en-US", { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;
};

export const roundDecimalnum = (number) => {
  return number.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const MoneyFormat1 = (number) => {
  return number / 100;
};
export const MoneyFormat2 = (number) => {
  return number * 100;
};

export const getDateTimeFormate = (createdDate) => {
  if (!createdDate) return "-";
  const inputDate = new Date(createdDate);
  if (isNaN(inputDate.getTime())) return "-";
  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };
  const dateFormatter = new Intl.DateTimeFormat("en-GB", options);
  const formattedDate = dateFormatter.format(inputDate);
  return formattedDate;

  // const dateComponents = createdDate && createdDate.split('T');
  // const dateParts = dateComponents && dateComponents[0].split('-');
  // const date = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
  // const time = dateComponents && dateComponents[1]?.slice(0, -1); // Removing 'Z' at the end

  // const formattedDateTime = `${date}, ${time}`;

  // return formattedDateTime;
};
export const getDateTimeFormateInvalidDate = (createdDate) => {
  const inputDate = new Date(createdDate);
  if (!createdDate) {
    return "-";
  }
  if (isNaN(inputDate)) {
    return "-";
  }
  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };
  const dateFormatter = new Intl.DateTimeFormat("en-GB", options);
  const formattedDate = dateFormatter.format(inputDate);
  return formattedDate;
};

export const getTimeFormat = (time) => {
  if (time >= 60) {
    const fullTime = time / 60;
    return fullTime;
  } else {
    return time;
  }
};

export const getTimeinMinutes = (time) => {
  const fullTime = time * 60;
  return fullTime;
};

export const getnumberWithCommas = (number) => {
  if (number !== null && number !== undefined) {
    const num = Number(number);
    // A zero denominator on the backend (e.g. averageStake with betCount 0)
    // comes through as NaN/Infinity - show "0" instead of literal "NaN"/"Infinity".
    if (!isFinite(num)) {
      return "0";
    }
    return num
      .toString()
      .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return "0";
  }
};

export const convertEndDatePickerTimeToMySQLTime = (str) => {
  if (str !== null && str !== undefined && str !== "") {
    var date = new Date(str);
    date.setHours(23, 59, 59);
    return date.toISOString();
  }
};

export const convertStartDatePickerTimeToMySQLTime = (str, page = "common") => {
  if (str !== null && str !== undefined && str !== "") {
    var date = new Date(str);
    const inputDate = new Date(str);
    var tempDate = new Date();
    const isToday = date.getDate() === tempDate.getDate();
    date.setHours(
      tempDate.getHours(),
      tempDate.getMinutes(),
      tempDate.getSeconds()
    );

    const utcTime = isToday ? date.toISOString() : inputDate.toISOString();

    // return utcTime;
    if (page === "bonus") {
      return utcTime;
    } else {
      var month, day, hours, minutes, seconds;
      var date = new Date(str);
      month = ("0" + (date.getMonth() + 1)).slice(-2);
      day = ("0" + date.getDate()).slice(-2);
      hours = "00";
      minutes = "00";
      seconds = "00";
      var mySQLDate = [date.getFullYear(), month, day].join("-");
      var mySQLTime = [hours, minutes, seconds].join(":");
      return [mySQLDate + "T", mySQLTime + ".517Z"].join("");
    }
  }
};

// export const convertStartDatePickerTimeToMySQLTime = (str) => {
//   var month, day, hours, minutes, seconds;
//   var date = new Date(str);
//   month = ("0" + (date.getMonth() + 1)).slice(-2);
//   day = ("0" + date.getDate()).slice(-2);
//   hours = "00";
//   minutes = "00";
//   seconds = "00";
//   var mySQLDate = [date.getFullYear(), month, day].join("-");
//   var mySQLTime = [hours, minutes, seconds].join(":");
//   return [mySQLDate + "T", mySQLTime + ".517Z"].join("");
// };

export const getFormateDate = (birth_date) => {
  if (birth_date != null || undefined) {
    let birthdate = new Date(birth_date);
    let getMonth = Number(birthdate.getMonth()) + 1;
    let getFullMonth = "";
    if (getMonth.toString().length < 2) {
      getFullMonth = "0" + getMonth;
    } else {
      getFullMonth = getMonth;
    }

    let getDay = "";
    if (birthdate.getDate().toString().length < 2) {
      getDay = "0" + birthdate.getDate();
    } else {
      getDay = birthdate.getDate();
    }
    // var fullDate = getDay + "/" + getFullMonth + "/" + birthdate.getFullYear();
    var fullDate = birthdate.getFullYear() + "-" + getFullMonth + "-" + getDay;

    return fullDate;
  } else {
    return "-";
  }
};

export const hideInfo = (str, upto, flag) => {
  if (str !== "" && str !== null && str !== undefined) {
    const input = str !== "" && str ? str.trim() : str;
    const outArr = [];
    for (let i = 0; i < 5; i++) {
      if (flag != true && i <= upto) {
        outArr.push(input[i]);
      }
      if (flag != true && i > upto && i !== "@") {
        outArr.push("*");
      }
      if (flag != true && i === "@") {
        outArr.push(input[i]);
      }
      if (flag == true) {
        return str;
      }
    }
    return outArr.join("");
  }
};

// Masking the whole data //
export const hideData = (str, temp) => {
  if (str !== "" && str !== null && str !== undefined && temp != true) {
    const input = str;
    const mask = "*";
    let maskedName = input.substring(0, 0) + mask.repeat(input.length);
    return maskedName;
  }
  if (temp == true) {
    return str;
  }
};
// Masking the whole data //

// For Bank IFSC code masking //
export const showfirst4 = (str, temp) => {
  if (str !== "" && str !== null && str !== undefined && temp != true) {
    const input = str;
    const mask = "*";
    let maskedName = input.substring(0, 4) + mask.repeat(input.length);
    return maskedName;
  }
  if (temp == true) {
    return str;
  }
};
// For Bank IFSC code masking //

// For Bank Account-No masking //
export const hideAccNo = (num, temp) => {
  if (num !== "" && num !== null && num !== undefined && temp != true) {
    let subNum = num.toString().replace(/\d(?=\d{4})/g, "*");
    return subNum;
  }
};
// For Bank Account-No masking //

export const hideEmail = (str, temp) => {
  if (str !== "" && str !== null && str !== undefined && temp != true) {
    const input = str;
    const mask = "*";
    let maskedName = input.substring(0, 3) + mask.repeat(input.length);
    return maskedName;
  }
  if (temp == true) {
    return str;
  }
};

export const hideMobile = (str, temp) => {
  // const toFix = (inp) => {
  //   let fix = 0;
  //   inp.length == 10 && (fix = 2);
  //   inp.length == 11 && (fix = 3);
  //   inp.length == 12 && (fix = 4);
  //   inp.length == 13 && (fix = 5);
  //   return fix;
  // };

  if (str !== "" && str !== null && str !== undefined && temp != true) {
    const input = str;
    return input.replace(/\d(?=\d{4})/g, "*");
  }
  if (temp == true) {
    return str;
  }
};

// export const hideMobile = (str, upto) => {
//   const stoping = str.length - 2;

//   const input = str.trim();
//   const outArr = [];
//   for (let i = 0; i < input.length; i++) {
//     if (i <= upto) {
//       outArr.push(input[i]);
//     }
//     if (i > upto && i < stoping) {
//       outArr.push("*");
//     }
//     if (i >= stoping) {
//       outArr.push(input[i]);
//     }
//   }
//   return outArr.join("");
// };

export const fixedDigit = (number, digit) => {
  const nums = ["0", "1", "2", "3", "4", "5", "6", " 7", "8", "9", "."];

  if (number != null && undefined && nums.includes(number)) {
    return Number(number).toFixed(digit);
  } else {
    return number;
  }
};

// Applies boostedOddsPercentage (e.g. 10 => +10%) to the base odds. Returns
// the base odds unchanged when no valid boost percentage is present, so
// callers can always use the result without branching.
export const getBoostedOdds = (odds, boostedOddsPercentage) => {
  const base = Number(odds);
  const pct = Number(boostedOddsPercentage);
  if (odds == null || !Number.isFinite(base)) return null;
  if (boostedOddsPercentage == null || !Number.isFinite(pct) || pct === 0) return base;
  return base * (1 + pct / 100);
};

export const get2DigitAfterDecimal = (num) => {
  if (num != null && num != undefined) {
    return Number(num).toFixed(2);
  } else {
    return num;
  }
};

export const usFormat = (num) => {
  if (num != null && num != undefined) {
    // return num.toLocaleString("en-US", {});
    const inp = +(num / 100).toFixed(2);
    // return inp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return inp.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  } else {
    return "0";
  }
};

export const colorArray = [
  "#FF6633",
  "#FFB399",
  "#FF33FF",
  // "#FFFF99",
  "#00B3E6",
  "#E6B333",
  "#3366E6",
  "#999966",
  "#99FF99",
  "#B34D4D",
  // "#80B300",
  //"#809900",
  // "#E6B3B3",
  "#6680B3",
  // "#66991A",
  // "#FF99E6",
  "#CCFF1A",
  "#FF1A66",
  "#E6331A",
  "#33FFCC",
  "#66994D",
  "#B366CC",
  "#4D8000",
  "#B33300",
  "#CC80CC",
  "#66664D",
  "#991AFF",
  "#E666FF",
  "#4DB3FF",
  "#1AB399",
  "#E666B3",
  "#33991A",
  "#CC9999",
  "#B3B31A",
  "#00E680",
  "#4D8066",
  "#809980",
  "#E6FF80",
  "#1AFF33",
  "#999933",
  "#FF3380",
  "#CCCC00",
  "#66E64D",
  "#4D80CC",
  "#9900B3",
  "#E64D66",
  "#4DB380",
  "#FF4D4D",
  "#99E6E6",
  "#6666FF",
];

export const getDob = (dob) => {
  if (dob != null && dob != undefined) {
    const dateArray = dob.split("-");
    const fullDob = dateArray[2] + "/" + dateArray[1] + "/" + dateArray[0];
    return fullDob;
  }
};

// export const sortingArray = (arr, key) => {
//   [
//     ...new Map(props.userPermission.map((item) => [item.id, item])).values(),
//   ].sort((a, b) => a.id - b.id);
// }
export const regexType = {
  alphanospace: /^[A-Za-z0-9]+$/,
  alpha: /^[a-zA-Z ]*$/,
  numeric: /^[0-9\b]*$/,
  validNumeric: /^[1-9][0-9]*$/,
  decimalNumeric: /^[0-9.\b]*$/,
  decimalPercentage: /^[0-9.%]*$/,
  alphaNumeric: /^[a-zA-Z0-9" "]*$/,
  multiWord: /^[a-z](?:_?[a-z0-9" "-_]+)*$/i,
  multiNumeric: /^[0-9]+(\.[0-9]{1,2})?$/,
  decimalNumber: /^(([0-9])(\.[0-0]{0,2})?$|([0-9])(\.[0-9]{1,2})?$)/,
  maxNumber: (max) => `/^[1-9][0-9]?$|^${max}$/`,
  // /^[1-9][0-9]?$|^100$/
  email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
  // email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  simplePassword: /^[a-zA-Z0-9@$.!#%&*]*$/,
  password:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
  phone: /^[0-9]{10}$/,
  name: /^[a-zA-Z ]{2,30}$/,
  number: /^[0-9]{1,10}$/,
  address: /^[a-zA-Z0-9\s,.'-]{2,100}$/,
  city: /^[a-zA-Z\s]{2,30}$/,
  state: /^[a-zA-Z\s]{2,30}$/,
  zip: /^[0-9]{5,10}$/,
  country: /^[a-zA-Z\s]{2,30}$/,
  date: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
  time: /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/,
  dateTime:
    /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2} ([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/,
  dateTime24:
    /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2} ([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/,
  ipAddress: /^[\0-9.]*$/,
  decimalafternum: /^(?!0{2,})(?!\.$)[0-9]{0,13}(?:\.(?!0{4,})[0-9]{0,20})?$/,
  numericPercentage: /^[0-9%]*$/,
  oneDecimal: /^(\d*)\.{0,1}(\d){0,9}$/,
  upto100: /^([1-9]|[1-9][0-9]|100)$/,
  notZero: /^[^a-zA-Z!@#$%^&*()_+=[\]{}|;':",./<>?]*$/,
  numOnly4Digit: /^\d{0,4}(\.\d{0,1})?$/,
  numOnly2Digit: /^\d{0,6}(\.\d{0,2})?$/,
  cryptoAmount: /^\d{0,12}(\.\d{0,10})?$/,
};

export const FalsyCleanObject = (obj) => {
  for (var propName in obj) {
    if (
      obj[propName] == null ||
      obj[propName] === undefined ||
      obj[propName] === ""
      // obj[propName] == ''
      // obj[propName] === 0 ||
      // obj[propName].length === 0
      // obj[propName] == 'NaN-aN-aNT23:59:59.517Z' ||
      // obj[propName] == 'NaN-aN-aNT00:00:00.517Z'
    ) {
      delete obj[propName];
    }
  }
  return obj;
};
// clearing Function that removes faslsy values from the payload
export const cleanObject = (obj) => {
  for (var propName in obj) {
    if (
      obj[propName] == null ||
      obj[propName] === undefined ||
      obj[propName] === "" ||
      obj[propName] == "" ||
      obj[propName] === 0 ||
      obj[propName].length === 0 ||
      (Array.isArray(obj[propName]) &&
        obj[propName].length === 1 &&
        typeof obj[propName][0] === "object" &&
        Object.keys(obj[propName][0]).length === 0)
    ) {
      delete obj[propName];
    }
  }
  return obj;
};

// Cleaning Function that removes empty values from the payload (flase will not be removed)
export const cleanPayload = (payload) => {
  return Object.fromEntries(
    Object.entries(payload).filter(
      ([key, value]) => value !== "" && value !== null && value !== undefined
    )
  );
};

export const generateCode = (length) => {
  var result1 = "";
  var characters = "abcdefghijklmnopqrstuvwxyz";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result1 += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result1;
};

export const getBaseUrl = (cyrusApi, upsApi) => {
  var mainBaseUrl = "";
  // const brandID = `${localStorage.getItem("brandId")}`;
  const isExist = localStorage.getItem("isExist");
  switch (isExist) {
    case "GAMEWORX_PERMISSION":
      mainBaseUrl = cyrusApi;
      break;
    // case "53":
    //   mainBaseUrl = "https://dev.platform-ups.negroup-tech.net/";
    //   break;
    default:
      mainBaseUrl = upsApi;
  }
  return mainBaseUrl;
};

export function getPath(param) {
  const urlPath = window.location.pathname;
  const urlParams = urlPath.split("/");
  function checker(checker) {
    return urlParams.some((val) => val === checker);
  }
  const isPresent = checker(param);
  var mainPathObject = {
    isExist: isPresent,
    urlParams: urlParams,
    urlPath: urlPath,
    searchKey: param,
  };
  return mainPathObject;
}

export function Currency() {
  const selected = localStorage.getItem('currency');
  const Default = "INR"   //'â‚¹';
  const code = selected || Default;
  return getSymbolFromCode(code) === undefined || null ? selected : getSymbolFromCode(code);
}

export function Country() {
  return localStorage.getItem("currency");
}
export const getUTCDate = (date, type) => {
  if (date !== undefined && date !== null && date !== "") {
    let utcFullDate = new Date(date);
    if (type === "start") {
      utcFullDate.setHours(0, 0, 0, 0);
    } else {
      utcFullDate.setHours(23, 59, 59);
    }
    return utcFullDate.toISOString();
  } else {
    return null;
  }
};

export const setToLocalStorage = (key, value) => {
  const encodedData = btoa(value);
  localStorage.setItem(key, encodedData);
};

export const getFromLocalStorage = (key) => {
  const data = localStorage.getItem(key);
  return data === null ? null : atob(data);
};
export const removeFromLocalStorage = (key) => {
  localStorage.removeItem(key);
};

export const generateKey = (dem) => {
  return `${dem}_${Date.now()}`;
};

export function sortingFilter(data, { key, sortType, keyType }) {
  // console.log("{key, sortType, keyType }: ", {key, sortType, keyType });
  const fetchedData = [...data];
  const sortData = fetchedData.sort((a, b) => {
    if (keyType === "num") {
      if (Number(a[key]) > Number(b[key])) return 1;
      else if (Number(a[key]) < Number(b[key])) return -1;

      return 0;
    }
    if (keyType === "date") {
      const date1 = new Date(a[key]).getTime();
      const date2 = new Date(b[key]).getTime();
      return date1 - date2;
    }
    if (keyType === "str") {
      // return a[key] - b[key];
      if (a[key] > b[key]) return 1;
      else if (a[key] < b[key]) return -1;

      return 0;
    }
    // else{
    //   if (a[key] > b[key]) return 1;
    //   else if (a[key] < b[key]) return -1;

    //   return 0;
    // }
  });

  if (sortType !== "") {
    return sortType === "ASCENDING" ? sortData.reverse() : sortData;
  } else {
    return data;
  }
}
export const replaceWithSpace = (value) => {
  if (value != null) {
    return value.replace(/_/g, " ");
  }
};

export function messageEnhancer(msg) {
  if (msg) {
    const checkISRawString = [...msg].some((l) => l == "_");
    if (checkISRawString) {
      const splitted = msg.split("_");
      const loweredArr = splitted.map(
        (v) => `${v[0]}${v.slice(1, v.length).toLowerCase()}`
      );
      const output = loweredArr.join(" ");
      return output;
    } else {
      return msg;
    }
  } else {
    return "";
  }
}

export const toaster = {
  success: (msg) => toast.success(msg),
  error: (msg) => toast.error(msg),
  info: (msg) => toast.info(msg),
  warning: (msg) => toast.warning(msg),
  warn: (msg) => toast.warn(msg),
  dark: (msg) => toast.dark(msg),
};

export const notySubscribe = () => (dispatch) => {
  const auth = localStorage.getItem("auth");
  const brandId = localStorage.getItem("brandId");
  const endPoint = localStorage.getItem("endpoint");
  const key = localStorage.getItem("Publickey");
  const token = localStorage.getItem("token");
  const id = localStorage.getItem("logUserId");
  dispatch(notificationSubscribe(auth, brandId, endPoint, key, token, id));
};

export const notyUnSubscribe = () => (dispatch) => {
  const auth = localStorage.getItem("auth");
  const brandId = localStorage.getItem("brandId");
  const endPoint = localStorage.getItem("endpoint");
  const key = localStorage.getItem("Publickey");
  const token = localStorage.getItem("token");
  const id = localStorage.getItem("logUserId");
  if (!auth || !endPoint || !key) return;
  dispatch(notificationUnSubscribe(auth, brandId, endPoint, key, token, id));
};

export const urlB64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
};

export const divideAmountBy100 = (paymentDesc) => {
  const amountRegex = /Amount (\d+)/;
  const match = paymentDesc?.match(amountRegex);
  if (!match) {
    return paymentDesc;
  }
  const originalAmount = parseInt(match[1]);
  const newAmount = originalAmount / 100;
  const modifiedPaymentDesc = paymentDesc.replace(
    amountRegex,
    `Amount ${newAmount}`
  );
  return modifiedPaymentDesc;
};

export const refreshTokenApi = () => {
  const url = userApi.refreshToken;
  const refreshToken = localStorage.getItem("refreshToken");
  const payload = {
    refreshToken: refreshToken
  }
  return apiCaller(url, "POST", payload).then(
    res => {
      if (res.status === 200 && res.msg === "LOGIN_SUCCESS") {
        // console.log("success");
        localStorage.setItem("token", res.data.accessToken)
        // localStorage.setItem("newRefreshToken", res.data.refreshToken)
        window.location.href = "/";
      } else {
        localStorage.clear();
        window.location.href = "/login";
      }
    }).catch(err => {
      // console.log("err.msg: ", err);
      // window.location.href = '/login'
    });
};

export const extractedDateTime = (date) => {
  //extracting both date and time
  const propDate = new Date(date);
  const day = propDate.getDate();
  const month = propDate.getMonth();
  const year = propDate.getFullYear();
  const hours = propDate.getHours();
  const minutes = propDate.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12;

  const finalDateTime = `${day}/${month}/${year} ${formattedHours}:${minutes} ${ampm}`;
  return finalDateTime;
};

export const MomentUTCDateTime = (dateString) => {
  // Replaces moment(dateString, '...').utc().format()
  // new Date() natively parses Date.toString() format: 'ddd MMM DD YYYY HH:mm:ss GMT+NNNN (Timezone)'
  const d = new Date(dateString);
  if (isNaN(d.getTime())) return '';
  return d.toISOString();
}

export const MomentUTCDateTimeConcat = (dateString) => {
  const date = dateString && new Date(dateString);
  const utcTime =
    date && new Date(date.getTime() + date.getTimezoneOffset() * 60000);

  if (!(utcTime instanceof Date && !isNaN(utcTime))) {
    return null; // or any other appropriate value indicating failure
  }

  if (utcTime.getUTCHours() < date.getUTCHours()) {
    utcTime.setUTCDate(utcTime.getUTCDate() + 1);
  }

  const year = utcTime.getUTCFullYear();
  const month = String(utcTime.getUTCMonth() + 1).padStart(2, "0");
  const day = String(utcTime.getUTCDate()).padStart(2, "0");
  const hours = String(utcTime.getUTCHours()).padStart(2, "0");
  const minutes = String(utcTime.getUTCMinutes()).padStart(2, "0");
  const seconds = String(utcTime.getUTCSeconds()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000Z`;
};
export const MomentUTCDateTimeToday = (selectedDate) => {
  const parsedDate = new Date(selectedDate);

  if (!isNaN(parsedDate.getTime())) {
    parsedDate.setHours(0, 0, 0, 0);

    const adjustedUTCDate = new Date(
      parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000
    );

    const payloadDate = adjustedUTCDate.toISOString();
    return payloadDate;
  } else {
    console.error("Invalid date string:", selectedDate);
    return "";
  }
};

export const MomentUTCDateTimeEnd = (dateString) => {
  const parsedDate = new Date(dateString);

  if (!isNaN(parsedDate.getTime())) {
    parsedDate.setHours(23, 59, 59, 0);

    const adjustedUTCDate = new Date(
      parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000
    );

    const formattedEndDate = adjustedUTCDate.toISOString();

    return formattedEndDate;
  } else {
    console.error("Invalid date string:", dateString);
    return "";
  }
};

export const toISOWithTime = (dateStr, timeStr) => {
  if (!dateStr) return "";

  const normalizedDateStr =
    dateStr instanceof Date
      ? [
        dateStr.getFullYear(),
        String(dateStr.getMonth() + 1).padStart(2, "0"),
        String(dateStr.getDate()).padStart(2, "0"),
      ].join("-")
      : String(dateStr);

  const [y, m, d] = normalizedDateStr.split("-").map(Number);
  const now = new Date();

  let hours = 0;
  let minutes = 0;

  if (timeStr && timeStr.includes(":")) {
    const [h, mm] = timeStr.split(":");
    hours = Number(h) || 0;
    minutes = Number(mm) || 0;
  } else {
    const isToday =
      y === now.getFullYear() &&
      m - 1 === now.getMonth() &&
      d === now.getDate();

    if (isToday) {
      hours = now.getHours();
      minutes = now.getMinutes();
    }
  }

  const utcDate = new Date(Date.UTC(y, m - 1, d, hours, minutes, 0, 0));
  return utcDate.toISOString();
};

export const SyndicateTimeStart = (selectedDate) => {
  const parsedDate = new Date(selectedDate);
  if (isNaN(parsedDate.getTime())) {
    console.error("Invalid date string:", selectedDate);
    return null;
  }
  const startOfDay = new Date(
    parsedDate.getFullYear(),
    parsedDate.getMonth(),
    parsedDate.getDate(),
    0,
    0,
    0,
    0
  );
  const utcStartOfDay = new Date(
    startOfDay.getTime() - startOfDay.getTimezoneOffset() * 60000
  );
  return utcStartOfDay;
};

export const SyndicateTimeEnd = (selectedDate) => {
  const parsedDate = new Date(selectedDate);
  if (isNaN(parsedDate.getTime())) {
    console.error("Invalid date string:", selectedDate);
    return null;
  }
  const endOfDay = new Date(
    parsedDate.getFullYear(),
    parsedDate.getMonth(),
    parsedDate.getDate(),
    23,
    59,
    59,
    999
  );
  const utcEndOfDay = new Date(
    endOfDay.getTime() - endOfDay.getTimezoneOffset() * 60000
  );
  return utcEndOfDay;
};

export const extractedDate = (date) => {
  //extracting only date
  const propDate = new Date(date);
  const day = propDate.getDate();
  const month = propDate.getMonth();
  const year = propDate.getFullYear();

  const finalDate = `${day}/${month + 1}/${year}`;
  return finalDate;
};

export const extractedTime = (date) => {
  const propDate = new Date(date);
  const hours = propDate.getHours();
  const minutes = propDate.getMinutes();

  // Convert to 24-hour format
  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");

  const finalTime = `${formattedHours}:${formattedMinutes}`;
  return finalTime;
};

export const extractDate = (dateString) => {
  const date = new Date(dateString);

  const extractedDate = date.getDate();
  const extractedMonth = date.toLocaleString("default", { month: "short" });
  const extractedYear = date.getFullYear();

  const extractedDateString = `${extractedDate} ${extractedMonth} ${extractedYear}`;
  return extractedDateString;
};

export const getFormattedDate = (daysAgo) => {
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - daysAgo);
  const formattedDate = currentDate.toISOString().split("T")[0];
  return new Date(formattedDate);
};

export const getFuturedDate = (daysAfter) => {
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + daysAfter);
  const formattedDate = currentDate.toISOString().split("T")[0];
  return new Date(formattedDate);
};

export const formatNumberWithK = (number) => {
  const shortenNumber = (num) => {
    const shortNum = (num / 1e9).toFixed(1);
    // console.log(shortNum, "shortNum");
    return `${shortNum}K`;
  };

  const numString = number.toString();
  if (numString.length >= 13) {
    return shortenNumber(number);
  }
};

// const dateTime = new Date(createdDate);

//   // Extract date components
//   const day = dateTime.getUTCDate();
//   const month = dateTime.getUTCMonth() + 1; // Months are zero-based
//   const year = dateTime.getUTCFullYear();

//   // Pad single digits with leading zero
//   const formattedDate = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;

//   // Extract time components
//   const hours = dateTime.getUTCHours();
//   const minutes = dateTime.getUTCMinutes();
//   const seconds = dateTime.getUTCSeconds();

//   // Format time
//   const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

//   return `${formattedDate}, ${formattedTime}`;

export const getIsOssino = () => {
  const isOssino = localStorage.getItem("brandId");
  return isOssino === "377";
};

export const convertToUSD = (amount, exchangeRate, currencyCode) => {
  if (
    amount === null ||
    amount === undefined ||
    exchangeRate === null ||
    exchangeRate === undefined
  ) {
    return "-";
  }
  const numAmount = Number(amount);
  const numRate = Number(exchangeRate);
  if (Number.isNaN(numAmount) || Number.isNaN(numRate)) {
    return "-";
  }
  const usdValue = numAmount * numRate;
  return usdValue.toFixed(2);
};
export const getSelectedLabel = (data, value) => {
  const found = data?.find(item => item.value === value);
  return found ? found.label : "Select";
};

export const getListOfURLs = (pattern) => (dispatch) => {
  const url = biReportLinksV2.downloadableURLsListAPI(pattern)
  apiCaller(url, "GET").then(res => {
    dispatch(setBiReportURLs(res.data));
  }).catch((err) => {
    // console.log("err.msg: ", err);
  })
}

export const downloadZipFile = async (key) => {
  const url = biReportLinksV2.downloadZipFile(key);

  try {
    const headers = {
      'Accept': 'application/zip, application/octet-stream, text/csv, */*',
      'Authorisation': localStorage.getItem('token'),
      'MerchantId': localStorage.getItem('merchantkey') || localStorage.getItem('merchantId'),
    };

    const response = await axios.request({
      url: url,
      method: 'GET',
      responseType: 'blob',
      headers: headers,
    });

    const blob = response.data;

    if (!blob || blob.size === 0) {
      toaster.error('Downloaded file is empty.');
      return;
    }

    const contentType = response.headers['content-type'] || '';
    const isZip = contentType.includes('application/zip') || contentType.includes('application/x-zip-compressed');
    const isCsv = contentType.includes('text/csv') || contentType.includes('application/csv');

    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;

    const rawFileName = key.split('/').pop() || 'download';
    const formattedName = formatReportFileName(rawFileName);

    let fileName;
    if (isCsv) {
      fileName = formattedName ? `${formattedName}.csv` : 'download.csv';
    } else if (isZip) {
      fileName = formattedName ? `${formattedName}.zip` : 'download.zip';
    } else {
      const extension = blob.type.includes('csv') ? 'csv' : 'zip';
      fileName = formattedName ? `${formattedName}.${extension}` : `download.${extension}`;
    }

    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);

    toaster.success('Download started successfully');
  } catch (error) {
    if (error.code === 'ECONNABORTED') {
      toaster.error('Download timeout.');
    } else if (error.response?.status === 504) {
      toaster.error('Gateway timeout.');
    } else {
      toaster.error('Failed to download file.');
    }
  }
}

export const formatReportFileName = (rawName) => {
  if (!rawName) return "";

  // For these types show clean type name + download datetime
  const playerTypeMap = [
    { pattern: /^playerSearchDownloadUrl_/i, label: "Player Search" },
    { pattern: /^playerActivityDownloadUrl_/i, label: "Player Activity" },
    { pattern: /^activePlayersDownloadUrl_/i, label: "Active Players" },
    { pattern: /^newPlayersDownloadUrl_/i, label: "New Players" },
  ];
  for (const { pattern, label } of playerTypeMap) {
    if (pattern.test(rawName)) {
      const dateMatch = rawName.match(/_(\d{8})_(\d{6})/);
      if (dateMatch) {
        const d = dateMatch[1];
        const t = dateMatch[2];
        const formatted = `${d.slice(6, 8)}-${d.slice(4, 6)}-${d.slice(2, 4)} ${t.slice(0, 2)}:${t.slice(2, 4)}`;
        return `${label} (${formatted})`;
      }
      return label;
    }
  }

  let name = rawName.replace(/^[a-zA-Z]+Url_/i, "");
  const dateMatches = name.match(/\d{8}/g);
  let fromDate = "";
  let toDate = "";

  if (dateMatches && dateMatches.length >= 2) {
    fromDate = formatDate(dateMatches[0]);
    toDate = formatDate(dateMatches[1]);
  }
  name = name.split(`_${dateMatches?.[0]}`)[0];
  name = name.replace(/-/g, " ");
  name = name.replace(/_/g, " ");
  name = name.replace(/\b\w/g, (char) => char.toUpperCase());
  if (fromDate && toDate) {
    return `${name} (${fromDate} to ${toDate})`;
  }

  return name;
};

const formatDate = (dateStr) => {
  const year = dateStr.substring(2, 4);
  const month = dateStr.substring(4, 6);
  const day = dateStr.substring(6, 8);
  return `${day}-${month}-${year}`;
};

export const getDateTimeFromKey = (key) => {
  const match = key.match(/_(\d{8})_(\d{6})/);
  if (!match) return 0;
  const [_, date, time] = match;
  return new Date(
    `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}T` +
    `${time.slice(0, 2)}:${time.slice(2, 4)}:${time.slice(4, 6)}`
  ).getTime();
};

export const getReportNameFromKey = (key) => {
  const match = key.match(/generic_report_(.*?)_\d{8}_\d{6}_part\d+/);
  return match ? match[1] : "";
};

export const getPartNumberFromKey = (key) => {
  const match = key.match(/part(\d+)/i);
  return match ? parseInt(match[1], 10) : 0;
};

export const MomentUTCDateTimeExact = (selectedDate) => {
  const parsedDate = new Date(selectedDate);
  if (!isNaN(parsedDate.getTime())) {
    // Proper UTC conversion - toISOString() already returns UTC format
    return parsedDate.toISOString();
  } else {
    return '';
  }
};

export const getLastNMinutes = (minutes) => {
  const to = new Date();
  const from = new Date(to.getTime() - minutes * 60 * 1000);
  return { from, to };
};

export const getDateTimePickerConfig = (afterValue, beforeValue, afterErrMsg = "") => {
  const now = new Date();
  const endOfDay = new Date(new Date().setHours(23, 59, 59, 999));
  const startOfDay = new Date(new Date().setHours(0, 0, 0, 0));
  const isToday = (date) => date ? new Date(date).toDateString() === now.toDateString() : true;
  return {
    0: { maxDate: beforeValue ? new Date(beforeValue) : now, minDate: null, maxTime: isToday(afterValue) ? now : endOfDay, minTime: startOfDay, errorMsg: afterErrMsg },
    1: { maxDate: now, minDate: afterValue || null, maxTime: isToday(beforeValue) ? now : endOfDay, minTime: startOfDay, errorMsg: "" },
  };
};

export const getPermissionForSportsBook = (per, userPagePermission = []) => {
  const isPermissionAvailable = userPagePermission?.some((permission) => permission?.permissionName === per);
  return isPermissionAvailable;
}

const CRYPTO_SYMBOLS = {
  // Major
  BTC: "₿", ETH: "Ξ", USDT: "₮", USDC: "USDC", BNB: "BNB", DAI: "DAI",
  SOL: "◎", XRP: "✕", ADA: "₳", DOGE: "Ð", LTC: "Ł",
  // DeFi & Layer 2
  TRX: "TRX", MATIC: "MATIC", POL: "POL", DOT: "DOT", AVAX: "AVAX",
  LINK: "LINK", UNI: "UNI", ATOM: "ATOM", XLM: "XLM", ALGO: "ALGO",
  NEAR: "NEAR", FTM: "FTM", OP: "OP", ARB: "ARB", APT: "APT",
  SUI: "SUI", INJ: "INJ", SEI: "SEI",
  // Stablecoins
  DAI: "DAI", BUSD: "BUSD", TUSD: "TUSD", FRAX: "FRAX", PYUSD: "PYUSD",
  // Other popular
  SHIB: "SHIB", PEPE: "PEPE", FLOKI: "FLOKI",
  XMR: "ɱ", ZEC: "ZEC", DASH: "DASH", ETC: "ξ",
  SAND: "SAND", MANA: "MANA", AXS: "AXS", CHZ: "CHZ",
  VET: "VET", HBAR: "HBAR", EOS: "EOS", XTZ: "XTZ",
  EGLD: "EGLD", FLOW: "FLOW", ICP: "ICP", FIL: "FIL",
  AAVE: "AAVE", CRV: "CRV", MKR: "MKR", COMP: "COMP", SNX: "SNX",
};

// Same rule as getConvertedAmountWithCurrency: currencies outside MULTIPLIER_100_CURRENCIES are crypto (stored x 10^10)
export const isCryptoCurrency = (code) =>
  !!code && !MULTIPLIER_100_CURRENCIES.includes(String(code).toUpperCase());

export function getCurrencySymbol(code) {
  if (!code) return "";
  const upper = code.toUpperCase();
  // Crypto first, then fiat via library (covers all ISO 4217 fiat codes), then raw code
  return CRYPTO_SYMBOLS[upper] ?? getSymbolFromCode(upper) ?? code;
}

export const getConvertedAmountWithCurrency = (amount, currencyCode, exchangeRate) => {
  if (amount == null || amount === undefined || amount === "") return "-";
  if (currencyCode == null || currencyCode === undefined || currencyCode === "") return amount;

  // console.log("amount, currencyCode, exchangeRate: ", amount, currencyCode, exchangeRate);

  const rate = exchangeRate != null ? Number(exchangeRate) : null;
  if (MULTIPLIER_100_CURRENCIES?.includes(currencyCode?.toUpperCase())) {
    const divided = Number(amount) / 100;
    return rate ? Number((divided / rate).toFixed(2)) : Number(divided.toFixed(2));
  } else {
    const divided = Number(amount) / 10000000000;
    return rate ? Number((divided / rate).toFixed(2)) : Number(divided.toFixed(10));
  }
}